/* eslint-disable max-len */
const team = [
    {
        id: 1,
        name: "Владимир Крылов",
        profession: "Frontend developer",
        vita: "Увлечения: каяки, багги, сплавы, скалолазание, шахматы, коньки, теннис, театры, мюзиклы. Читаю фэнтези.",
        skills: [
            "HTML (HTML5)",
            "CSS (CSS3)",
            "SCSS/SASS",
            "BEM",
            "Styled-Components",
            "FSD-methodology",
            "FLUX|MVC|MVP-architecture",
            "JavaScript (ES5+)",
            "TypeScript (4+)",
            "React (17+)",
            "Redux (4+) [pure+ toolkit, saga, thunk]",
            "Storybook",
            "Jest + screenshot testing",
        ],
        socials: {
            email: "krylov.dev@yandex.ru",
            github: "https://github.com/krylovDev",
            telegram: "https://t.me/krylov_dev",
        },
        photo: "https://raw.githubusercontent.com/ilrosch/dream-team/development/src/img/slider/photo_vladimir_krylov.jpg",
    },

    {
        id: 2,
        name: "Заур Нурмагомедов",
        profession: "Frontend developer",
        vita: "Frontend-разработчик, чутка шарящий в backend. Фанат японской манги. Очень хочет прописать sudo apt-get update.",
        skills: [
            "HTML (HTML5)",
            "CSS (CSS3)",
            "SCSS/SASS",
            "JavaScript (ES6)",
            "React",
            "Redux toolkit",
            "MUI",
            "Python",
            "FastAPI",
            "Flask",
            "SQL",
            "Linux",
        ],
        socials: {
            email: "nurmagomedoffzaur@yandex.ru",
            github: "https://github.com/mrskyguy",
            telegram: "https://t.me/skyguy",
        },
        photo: "https://raw.githubusercontent.com/ilrosch/dream-team/development/src/img/slider/photo_nurmagomedov_zaur.jpg",
    },

    {
        id: 3,
        name: "Илья Росчихмаров",
        profession: "Frontend developer, Web-designer",
        vita: "Если сказать кратко, то я «самоучка». Знания в области веб-программирования черпал из различных книг, статей и курсов на образовательных площадках Beonmax и Freecodecamp. Закончил обучение более 2-х лет назад, но до сих пор продолжаю совершенствовать свои навыки и изучаю новые технологии. Также имею опыт в разработке веб-дизайна.",
        skills: ["HTML (HTML5)", "CSS (CSS3)", "Sass/Scss", "JavaScript", "React", "BEM", "Gulp", "Figma", "Photoshop"],
        socials: {
            email: "ilrosch@yandex.ru",
            github: "https://github.com/ilrosch/",
            telegram: "https://t.me/ilrosch",
        },
        photo: "https://raw.githubusercontent.com/ilrosch/dream-team/development/src/img/slider/photo_Ilya_roschimarov.jpg",
    },

    {
        id: 4,
        name: "Сергей Сазонов",
        profession: "Frontend developer",
        vita: "Играю в футбол, волейбол, катаюсь на сноуборде, люблю готовить и играть в настольные игры.",
        skills: ["HTML (HTML5)", "CSS (CSS3)", "Python", "JavaScript", "React", "SQL", "Redux toolkit"],
        socials: {
            email: "ssazonov69@gmail.com",
            github: "https://github.com/OraPoulpe",
            telegram: "https://t.me/OraPoulpe",
        },
        photo: "https://raw.githubusercontent.com/ilrosch/dream-team/development/src/img/slider/photo_sergey_sazonov.jpg",
    },
];

export default team;
